/*
  VapeHouse: movimento do carrinho (drawer).
  Não substitui o cart.js do tema: envolve updateQuantity e open() e reage ao evento cartUpdate.
  - clique no + / − / caixote: a linha fica "pendente" de imediato (preço e total a meia opacidade), sem esperar pelo debounce
  - remover (caixote ou quantidade a 0): a linha colapsa antes do pedido ao servidor
  - depois de cada resposta: realce do artigo adicionado/atualizado, pulso no total e na bolha do cabeçalho
  - ao abrir o carrinho: os artigos entram escalonados
  Respeita prefers-reduced-motion.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pending = { line: null, type: null };
  var COLLAPSE_MS = 280;

  function drawer() { return document.querySelector('cart-drawer'); }
  function rowFor(line) {
    return document.getElementById('CartDrawer-Item-' + line) || document.getElementById('CartItem-' + line);
  }
  function footerPending(on) {
    var f = document.querySelector('cart-drawer .drawer__footer');
    if (f) f.classList.toggle('vh-pending', !!on);
  }
  function markPending(row, type) {
    if (!row) return;
    row.classList.add('vh-cart-item--pending');
    pending.line = row.id.replace(/^\D+/, '');
    pending.type = type || 'set';
    footerPending(true);
  }
  function clearPending() {
    document.querySelectorAll('.vh-cart-item--pending').forEach(function (r) { r.classList.remove('vh-cart-item--pending'); });
    footerPending(false);
  }
  function collapse(row) {
    return new Promise(function (resolve) {
      var h = row.getBoundingClientRect().height;
      row.style.height = h + 'px';
      row.classList.add('vh-cart-item--leaving');
      row.getBoundingClientRect();
      requestAnimationFrame(function () {
        row.style.height = '0px';
        row.classList.add('vh-cart-item--gone');
      });
      setTimeout(resolve, COLLAPSE_MS);
    });
  }
  function minOf(input) {
    var m = parseInt(input.dataset.min || input.min, 10);
    return isNaN(m) || m < 1 ? 1 : m;
  }
  /* o − fica visualmente desativado na quantidade mínima */
  function syncMinusButtons() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('.quantity__input');
      var minus = row.querySelector('.quantity__button[name="minus"]');
      if (!input || !minus) return;
      minus.classList.toggle('disabled', parseInt(input.value, 10) <= minOf(input));
    });
  }
  function replay(el, cls, ms) {
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    setTimeout(function () { el.classList.remove(cls); }, ms || 900);
  }

  /* 1. Feedback imediato no clique (antes do debounce de 300 ms do tema) */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('cart-drawer .quantity__button');
    if (btn) {
      var row = btn.closest('.cart-item');
      var input = row && row.querySelector('.quantity__input');
      var name = btn.getAttribute('name');
      /* o − na quantidade mínima não faz nada (o tema mostrava um aviso nativo de validação); remover é com o caixote */
      if (name === 'minus' && input && parseInt(input.value, 10) <= minOf(input)) {
        e.preventDefault(); e.stopPropagation();
        return;
      }
      markPending(row, name);
      return;
    }
    if (t.closest('cart-drawer cart-remove-button')) {
      var r = t.closest('.cart-item');
      if (r) { pending.type = 'remove'; pending.line = null; footerPending(true); }
    }
  }, true);

  /* 2. Envolver updateQuantity: colapso antes de remover, pendente nos outros casos */
  customElements.whenDefined('cart-items').then(function () {
    var Cls = customElements.get('cart-items');
    var proto = Cls.prototype;
    var original = proto.updateQuantity;
    proto.updateQuantity = function (line, quantity, name, variantId) {
      var self = this, args = arguments;
      var row = rowFor(line);
      var qty = parseInt(quantity, 10);
      if (row && qty === 0 && !reduce && !row.classList.contains('vh-cart-item--leaving')) {
        pending.type = 'remove'; pending.line = null; footerPending(true);
        row.classList.remove('vh-cart-item--pending');
        return collapse(row).then(function () { return original.apply(self, args); });
      }
      if (row && qty > 0) markPending(row, name || pending.type);
      return original.apply(self, args);
    };
    var originalDisable = proto.disableLoading;
    proto.disableLoading = function () {
      var r = originalDisable.apply(this, arguments);
      /* se o pedido falhou o DOM não foi substituído: limpar o estado pendente */
      setTimeout(clearPending, 0);
      return r;
    };
  });

  /* 3. Entrada escalonada ao abrir */
  customElements.whenDefined('cart-drawer').then(function () {
    var proto = customElements.get('cart-drawer').prototype;
    var originalOpen = proto.open;
    proto.open = function () {
      var self = this;
      var wasClosed = !self.classList.contains('active');
      if (!reduce && wasClosed) {
        self.classList.add('vh-cart-opening');
        setTimeout(function () { self.classList.remove('vh-cart-opening'); }, 900);
      }
      syncMinusButtons();
      var result = originalOpen.apply(this, arguments);
      /* avisa a barra de portes grátis para carregar de 0 até ao valor */
      if (wasClosed) document.dispatchEvent(new CustomEvent('vh:cart-drawer-open'));
      return result;
    };
  });

  /* 4. Depois de cada atualização: realces */
  function afterRender(event) {
    var d = drawer();
    if (!d) return;
    var row = null;
    if (event && event.source === 'product-form' && event.productVariantId) {
      row = d.querySelector('.cart-item[data-variant-id="' + event.productVariantId + '"]');
      if (row) replay(row, 'vh-cart-item--added', 1500);
    } else if (pending.line && pending.type !== 'remove') {
      row = rowFor(pending.line);
      if (row) replay(row, 'vh-cart-item--updated', 900);
    }
    syncMinusButtons();
    setTimeout(syncMinusButtons, 450); /* o tema volta a validar as regras de quantidade 50 ms depois de renderizar */
    replay(d.querySelector('.totals__total-value'), 'vh-pulse', 800);
    replay(document.querySelector('#cart-icon-bubble .cart-count-bubble'), 'vh-bubble-pulse', 700);
    footerPending(false);
    pending.line = null; pending.type = null;
  }
  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return setTimeout(bind, 100);
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      /* o product-form publica antes de renderizar e o drawer abre num setTimeout: esperar pelo painel */
      var delay = event && event.source === 'product-form' ? 260 : 0;
      setTimeout(function () { afterRender(event); }, delay);
    });
  }
  bind();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncMinusButtons); else syncMinusButtons();
  setTimeout(syncMinusButtons, 600);
})();
